<script>
import { mapGetters } from 'vuex'
import TabsSection from '@components/faq/faq-tabs.vue'

import Translatable from '@src/mixins/translatable.js'
import Resizable from '@src/mixins/resizable.js'

export default {
  components: {
    TabsSection,
  },
  mixins: [Translatable, Resizable],
  data() {
    return {
      categoryNum: 0,
    }
  },
  computed: {
    ...mapGetters('faq', {
      categories: 'dataFAQ',
    }),
    selectedCategory() {
      return this.categories[this.categoryNum] || []
    },
  },
  created() {
    this.$store.dispatch('faq/fetchFaqs')
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'faq/SET_FAQS') {
        this.$nextTick(() => {
          const firstSpoiler = document.querySelector('.spoiler')
          firstSpoiler.classList.toggle('active')
        })
      }
    })
  },
  methods: {
    setCategory(value, event) {
      const activeElements = document.querySelectorAll('.spoiler.active')
      const activeTabs = document.querySelectorAll('.spoiler-content.active')
      const activeArrow = document.querySelectorAll('.arrow.active')
      const spoilerContent =
        event.currentTarget.parentNode.querySelector('.spoiler')

      this.categoryNum = value
      this.activeToggle(activeElements)
      this.activeToggle(activeTabs)
      this.activeToggle(activeArrow)

      this.scrollToElement({ behavior: 'smooth' })

      spoilerContent.classList.toggle('active')
    },
    activeToggle(element) {
      element.forEach((el) => {
        el.classList.toggle('active')
      })
    },
    scrollToElement(options) {
      const faqList = this.desktopScreen
        ? document.querySelector('.description-banner-section')
        : document.querySelector('.tabs-container')

      if (faqList) {
        faqList.scrollIntoView(options)
      }
    },
  },
}
</script>

<template>
  <div class="section-container">
    <div class="categories-container">
      <div v-for="(category, index) in categories" :key="category.id">
        <div class="spoiler" @click.prevent="setCategory(index, $event)">
          <div
            class="icon"
            :style="{ maskImage: `url(${category.icon})` }"
          ></div>
          <p class="spoiler-title-text">
            {{ getTranslatedContent('title', category.title.content) }}
          </p>
        </div>
      </div>
    </div>
    <div class="tabs-container">
      <h2 class="tabs-title">{{
        getTranslatedContent(
          'title',
          selectedCategory.length ? selectedCategory.title.content : '',
        )
      }}</h2>
      <TabsSection :category-data="selectedCategory.data" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.section-container {
  display: flex;
  flex-direction: row;
}

.categories-container {
  height: auto;
  margin-right: 20px;
}

.spoiler {
  min-width: 175px;
  min-height: 77px;
  background-color: $light-gray;
  border-radius: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  user-select: none;

  &.active,
  &:hover {
    background-color: $white;
    box-shadow: 0 8px 12px rgba(76, 72, 124, 0.08);

    & .icon {
      mask-repeat: no-repeat;
      background-color: $orange;
    }

    & .spoiler-title-text {
      color: $orange;
    }
  }
}

.icon {
  background-color: $dark-blue;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.spoiler-title-text {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: $dark-blue;
  margin-left: 5px;
  text-align: center;
}

h2.tabs-title {
  font-family: Open sans bold, sans-serif;
  font-weight: bold;
  font-style: normal;
  font-size: 26px;
  line-height: 34px;
  color: $orange;
  margin-left: 28px;
}

.tabs-container {
  width: 100%;
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .section-container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .categories-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    margin: 0;
    padding: 0 5px;
  }

  .spoiler {
    height: 45px;
    min-width: 150px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 5px;
  }

  .tabs-container {
    margin-top: 20px;
  }

  h2.tabs-title {
    margin-left: 12px;
  }
  .spoiler-title-text {
    max-width: 70px;
  }
}
</style>
